module.exports = __webpack_public_path__ + "static/media/qualified_lead_banner.6ec1e42d.svg";